import styles from './Retangulo.module.css';
import { formatValor } from '../../../service/NumberService';

const abreviaUnidades = (valor, t) => {
  var valorlocal = valor;
  if(valor >= 1000000 && valor <= 999999999) {
      valorlocal = parseFloat(parseInt(valor) / 1000000).toFixed(3);
      return valorlocal + t("dashboard.retangulos.milhoes");
  } else if(valor >= 1000000000 && valor <= 999999999999){
      valorlocal = parseFloat(parseInt(valor) / 1000000000).toFixed(3);
      return valorlocal + t("dashboard.retangulos.bilhoes");
  } else return valor;
}

/*
const formatValor = (valor, language, mostraPercentual = false) => {
    // converte para número
    const num = Number(valor);

    // trata casos não-numéricos
    if (!Number.isFinite(num)) return "-";

    // escolhe quantidade de casas decimais
    const options = {
        minimumFractionDigits: Number.isInteger(num) ? 0 : 2,
        maximumFractionDigits: 2,
    };

    // aplica pontuação pt-BR
    const numeroFormatado = language == "pt" ? num.toLocaleString("pt-BR", options) : num.toLocaleString("en-US", options);

    //const numeroFormatado = num.toLocaleString("en-US", options);


    // acrescenta símbolo de % se solicitado
    return numeroFormatado + (mostraPercentual ? "%" : "");
}*/

const Retangulo = ({cor, nome, valor, perc, abrevia, t, language}) => {
  return (
    <div style={{backgroundColor:cor}} className={styles.container_retangulo}>
         <div className={styles.nome_variavel_retangulo}>{nome}</div>
         
         <div className={styles.valor_variavel_retangulo}>{(valor === "NaN" || isNaN(parseFloat(valor))) ? "-" : (Number.isInteger(valor) ? /*(abrevia ? abreviaUnidades(valor, t) :*/ formatValor(valor, language)/*)*/ :  formatValor(parseFloat(valor).toFixed(2), language))}{perc != null && perc ? "%" : ""}</div>
         
         
    </div>
  )
}

export default Retangulo